import { useEffect } from 'react';

interface DocumentMetadata {
  title: string;
  description?: string;
  canonicalUrl?: string;
  jsonLd?: unknown;
}

const ensureMeta = (name: string): HTMLMetaElement => {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    document.head.appendChild(element);
  }

  return element;
};

const ensureCanonical = (): HTMLLinkElement => {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');

  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }

  return element;
};

const ensureJsonLd = (): HTMLScriptElement => {
  let element = document.head.querySelector<HTMLScriptElement>(
    'script[data-managed-by="pumaweb"][type="application/ld+json"]'
  );

  if (!element) {
    element = document.createElement('script');
    element.type = 'application/ld+json';
    element.dataset.managedBy = 'pumaweb';
    document.head.appendChild(element);
  }

  return element;
};

export const useDocumentMetadata = ({
  title,
  description,
  canonicalUrl,
  jsonLd,
}: DocumentMetadata): void => {
  useEffect(() => {
    document.title = title;

    const descriptionMeta = ensureMeta('description');
    descriptionMeta.setAttribute('content', description || '');

    const canonicalLink = ensureCanonical();
    canonicalLink.setAttribute('href', canonicalUrl || window.location.href);

    if (jsonLd) {
      const jsonLdScript = ensureJsonLd();
      jsonLdScript.textContent = JSON.stringify(jsonLd);
    } else {
      document.head
        .querySelector('script[data-managed-by="pumaweb"][type="application/ld+json"]')
        ?.remove();
    }
  }, [canonicalUrl, description, jsonLd, title]);
};
